export default "__VITE_ASSET__C789L8Wb__"